
    import "/home/git/waysglob/website/src/components/slider/index.module.scss.FARM_CSS_MODULES?4fb76884";
    
    export default {"title": `title-3c0d2963`,"img": `img-3c0d2963`,"links": `links-3c0d2963`,"button": `button-3c0d2963`,"linksRight": `linksRight-3c0d2963`,"icon": `icon-3c0d2963`}
    